var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.117,
    height: 21.109,
    viewBox: "0 0 15.117 21.109",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32600",
    "data-name": "Group 32600",
    transform: "translate(-147.441 -3979.324)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_192090",
    "data-name": "Path 192090",
    d: "M29.4,10.067c0,4.967-4.387,10.636-6.477,13.054a1.427,1.427,0,0,1-2.163,0c-2.09-2.418-6.477-8.087-6.477-13.054a7.559,7.559,0,1,1,15.117,0Z",
    transform: "translate(133.157 3976.816)",
    fill: "#fc6559"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192091",
    "data-name": "Path 192091",
    d: "M32.88,11.04C32.88,16,28.5,21.681,26.4,24.1a1.427,1.427,0,0,1-2.153,0c-.248-.291-.54-.626-.83-1a1.383,1.383,0,0,0,1.6-.379C27.115,20.3,31.5,14.621,31.5,9.657a7.444,7.444,0,0,0-1.572-4.6,7.516,7.516,0,0,1,2.955,5.983Z",
    transform: "translate(129.675 3975.845)",
    fill: "#f05543"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3470",
    "data-name": "Ellipse 3470",
    cx: 3.898,
    cy: 3.898,
    r: 3.898,
    transform: "translate(151.102 3982.796)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192092",
    "data-name": "Path 192092",
    d: "M27.213,9.687A3.849,3.849,0,0,0,24.9,8.92a3.906,3.906,0,0,0-3.9,3.9,3.858,3.858,0,0,0,.767,2.327,3.9,3.9,0,1,1,5.445-5.457Z",
    transform: "translate(130.903 3974.676)",
    fill: "#eaeaf4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.a7491632a8fcbe466a6abc28b39f381f.svg";
export { ForwardRef as ReactComponent };